module.exports = __webpack_public_path__ + "videos/gestures_cn.6ef85e9.mp4";